/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var createCountdown = () => {
  var AnnouncementBarTimer = document.querySelector(".AnnouncementBarTimer");
  var timerElement = document.querySelector(
    ".AnnouncementBarTimer [data-date]"
  );

  if (AnnouncementBarTimer && timerElement) {
    var time = timerElement.dataset.date;
    var timer = new Date(time);

    setInterval(() => {
      var now = new Date();
      var diff = timer - now;

      if (diff > 0) {
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((diff % (1000 * 60)) / 1000);

        timerElement.innerHTML = `${
          days ? `${days}d : ` : ""
        }${hours}h : ${minutes}m : ${seconds}s`;
      } else {
        timerElement.innerHTML = `0d 0h 0m 0s`;
      }
    }, 1000);
  }
};

var adjustHelpMenu = () => {
  var Header__RightSide = document.querySelector(".Header__RightSide--Inner");

  if (!Header__RightSide) return;

  var Header__RightSideBox = Header__RightSide.getBoundingClientRect();
  var Header__RightSideMenu = document.querySelector(
    ".Header__RightSide--Menu"
  );

  if (!Header__RightSideMenu) return;

  Header__RightSideMenu.style.width = `${
    Header__RightSideBox.width + (innerWidth - Header__RightSideBox.right)
  }px`;
};

var adjustSidebar = () => {
  var sticky_wrapper = document.querySelector(".sticky-wrapper");

  if (!sticky_wrapper) return;

  var sticky_wrapper_box = sticky_wrapper.getBoundingClientRect();
  var sidebar_menu = document.querySelector("#sidebar-menu");

  if (!sidebar_menu) return;

  sidebar_menu.style.top = `${sticky_wrapper_box.height}px`;
  sidebar_menu.style.height = `calc(100% - ${sticky_wrapper_box.height}px)`;
};

var handleBaner = () => {
  var sections = document.querySelectorAll(".ImageHero");

  if (!sections) return;

  sections.forEach((section) => {
    var elements = section.querySelectorAll(".u_typewriter");

    elements.forEach((element) => {
      var letters = element.textContent.split("");
      var stagger = 2 / letters.length;

      element.textContent = "";
      letters.forEach((letter, index) => {
        var span = document.createElement("span");
        span.textContent = letter;
        span.style.display = "inline-block";
        span.setAttribute("style", `animation-delay: ${index * stagger}s`);
        element.append(span);
      });
    });

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            elements.forEach((element) => {
              element.offsetHeight;
              element.classList.add("animate");
            });
          } else {
            elements.forEach((element) => element.classList.remove("animate"));
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(section);
  });
};

var handleBlogTabs = () => {
  var blogTabs = document.querySelectorAll("[data-blog-tab-trigger] a");
  var blogTabsContent = document.querySelectorAll("[data-blog-tab]");

  blogTabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      var tabName = e.target.getAttribute("data-tab");
      var content = document.querySelector(tabName);

      blogTabs.forEach((item) => {
        item.classList.remove("is-active");
      });
      blogTabsContent.forEach((item) => {
        item.classList.remove("active");
      });

      tab.classList.add("is-active");
      content.classList.add("active");

      var sliderSettings = content
        .querySelector("[data-future-flickity]")
        .getAttribute("data-future-flickity");
      if (sliderSettings) {
        new Flickity(
          content.querySelector("[data-future-flickity]"),
          JSON.parse(sliderSettings)
        );
      }
    });
  });
};

var handleModal = () => {
  var invokingElements = document.querySelectorAll(
    "[data-modal-id]:not([aria-hidden])"
  );

  invokingElements.forEach((element) => {
    var modalId = element.getAttribute("data-modal-id");
    var modal = document.querySelector(
      `[data-modal-id="${modalId}"][aria-hidden]`
    );

    var closeModal = modal?.querySelectorAll(".Modal__Close--Button");

    var disableModal = () => {
      document.documentElement.classList.remove("no-scroll");
      modal.setAttribute("aria-hidden", true);
    };

    if ( closeModal ) {
      closeModal.forEach((el) => el.addEventListener("click", disableModal));
    }

    if ( modal ) {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) disableModal();
      });
    }

    element.addEventListener("click", () => {
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("no-scroll");
    });
  });
};

var handleShopTheLook = () => {
  var invokingElements = document.querySelectorAll(
    '.ShopTheLook__Item[data-modal-id="shop-the-look"]'
  );
  var modal = document.querySelector('.modal[data-modal-id="shop-the-look"]');

  if (!modal) return;

  var sliderElement = modal?.querySelector(".ShopTheLook__Slider");

  var prevMobile = sliderElement?.querySelectorAll(".header--mobile .prev");
  var nextMobile = sliderElement?.querySelectorAll(".header--mobile .next");

  prevMobile?.forEach((element) =>
    element.addEventListener("click", () => slider.previous())
  );
  nextMobile?.forEach((element) =>
    element.addEventListener("click", () => slider.next())
  );

  var widthMobileView = 640;

  var slider = new Flickity(sliderElement, {
    pageDots: false,
    adaptiveHeight: false,
    watchCSS: true,
    setGallerySize: innerWidth > widthMobileView ? true : false,
    prevNextButtons: innerWidth > widthMobileView ? true : false,
    arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 },
  });

  var firstSlideImage = sliderElement.querySelector(".Slide__Cell img");

  if (firstSlideImage && innerWidth > widthMobileView) {
    firstSlideImage.addEventListener("load", () => {
      var firstSlideImageBox = firstSlideImage.getBoundingClientRect();
      sliderElement.querySelector(
        ".flickity-viewport"
      ).style.height = `${firstSlideImageBox.height}px`;
    });

    if (!window?.lazySizes?.loader) return;

    window.lazySizes.loader.unveil(firstSlideImage);
  }

  invokingElements.forEach((element) =>
    element.addEventListener("click", (e) => {
      var slideID = e.target
        .closest(".ShopTheLook__Item[data-slide]")
        .dataset.slide.replace("slide-", "");
      slider.select(slideID, false, true);
    })
  );
};

var handleProductListingVideo = () => {
  var videos = document.querySelectorAll(
    ".ProductItem__ImageWrapper--playOnHover"
  );

  if (!videos) return;

  videos.forEach((video) => {
    video.addEventListener("mouseenter", () => {
      video.querySelector("video")?.play();
    });
    video.addEventListener("mouseleave", () => {
      video.querySelector("video")?.pause();
    });
  });
};

var handleAlternateOnVideo = () => {
  var wrappers = document.querySelectorAll(
    ".ProductItem__ImageWrapper--withAlternateImage"
  );

  wrappers.forEach((wrapper) => {
    var video = wrapper.querySelector("video");

    if (!video) return;

    wrapper.addEventListener("mouseenter", () => {
      video.pause();
    });

    wrapper.addEventListener("mouseleave", () => {
      video.play();
    });
  });
};

var handleListingInfiniteScroll = () => {
  var productsListing = document.querySelector(
    ".ProductList.ProductList--InfiniteScroll"
  );

  if (!productsListing) return;
  // Native collection roots own continuation through CollectionFilters.
  if (productsListing.closest("[data-native-listing-root]")) return;

  var lastItem = productsListing.querySelector(".Grid__Cell:last-child");

  if (!lastItem) return;

  var sectionID =
    productsListing.closest("[data-section-id]").dataset.sectionId;

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        var nextPage = productsListing.dataset.nextpage;
        if (nextPage) {
          observer.unobserve(lastItem);

          var url = new URL(`${location.origin}${nextPage}`);
          var searchParams = new URLSearchParams(url.search);

          // history.pushState(null, null, url)

          searchParams.append("section_id", sectionID);
          url.search = searchParams.toString();

          document.dispatchEvent(new Event("theme:loading:start"));

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var products = doc.querySelectorAll(".ProductList .Grid__Cell");
              products.forEach((product) => productsListing.append(product));
              productsListing.dataset.nextpage =
                doc.querySelector(".ProductList")?.dataset.nextpage;

              lastItem = productsListing.querySelector(
                ".Grid__Cell:last-child"
              );
              observer.observe(lastItem);

              document.dispatchEvent(new Event("theme:loading:end"));
              document.dispatchEvent(
                new CustomEvent("theme:scroll:end", {
                  detail: {
                    page: Number(searchParams.get("page")),
                  },
                })
              );
            });
        }
      }
    });
  });

  observer.observe(lastItem);
};

var handleListingLoadMoreButton = () => {

  var productsListing   = document.querySelector(".ProductList.ProductList--LoadMore");
  var loadMoreButton    = document.querySelector('.products__pagination button');

  if (!productsListing || !loadMoreButton) return;

  loadMoreButton.addEventListener('click', () => {

    var nextPage = productsListing.dataset.nextpage;
    if (nextPage) {

      var url = new URL(`${location.origin}${nextPage}`);
      var searchParams = new URLSearchParams(url.search);

      url.search = searchParams.toString();

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var products = doc.querySelectorAll(".ProductList .Grid__Cell");
          products.forEach((product) => productsListing.append(product));
          productsListing.dataset.nextpage =
            doc.querySelector(".ProductList")?.dataset.nextpage;

          var items = productsListing.querySelectorAll('.ProductItem');
          items.forEach((item) => {
            item.classList.add('is-revealed');
            item.style.visibility = "visible";
            item.style.opacity = "1";
          });

          var paginationCounter     = document.querySelector('.products__pagination .products__pagination--current');
          var paginationTotal       = Number( document.querySelector('.products__pagination .products__pagination--total').innerHTML );
          paginationCounter.innerHTML = Number(items.length);

          if ( items.length == paginationTotal ) {
            loadMoreButton.style.display = 'none';
          }

        });
    }
    
  });

};

var handleBanerVideos = () => {
  var videosHover = document.querySelectorAll(
    ".ImageHero__Video--play_on_hover"
  );
  var videosObserver = document.querySelectorAll(
    ".ImageHero__Video--play_on_visible"
  );

  if (videosHover) {
    videosHover.forEach((video) => {
      video.addEventListener("mouseenter", () => {
        video.play();
      });
      video.addEventListener("mouseleave", () => {
        video.pause();
      });
    });
  }

  if (videosObserver) {
    videosObserver.forEach((video) => {
      var observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      });

      observer.observe(video);
    });
  }
};

var handleCustomSelects = async () => {
  var selects = document.querySelectorAll(".Select__Wrapper select");

  if (!selects) return;

  selects.forEach((select) => {
    var slimselectInstance;
    var selectID;

    var inlineSettings =
      select.dataset.selectSettings &&
      JSON.parse(select.dataset.selectSettings);

    var defaultSettings = {
      showSearch: false,
      closeOnSelect: true,
      hideSelected: true,
      contentPosition: "relative",
      contentLocation: select.closest(".Select__Wrapper"),
    };

    var settings = inlineSettings
      ? { ...defaultSettings, ...inlineSettings }
      : defaultSettings;

    if (select.hasAttribute("data-size-select")) {
      //make size select globally accessible, so in theme.js on variant change we can refresh those and decide whether add 'notify about avaibility' button
      window.sizeSlimSelect = new SlimSelect({
        select,
        settings: { ...settings, openPosition: "down", timeoutDelay: 1 },
      });
      document.dispatchEvent(new CustomEvent("theme:select:loaded"));

      selectID = window.sizeSlimSelect.settings.id;
    } else {
      slimselectInstance = new SlimSelect({
        select,
        settings,
      });

      selectID = slimselectInstance.settings.id;
    }

    //on mobile select behaviour is replaced by drawer
    var handleMobile = (e) => {
      var overlayElement = document.querySelector(".PageOverlay");
      var drawer = document.querySelector(
        `.Drawer__Custom[data-option-name="${select.dataset.optionName}"]`
      );

      if (!drawer) return;

      element.classList.add("ss-hidden-options");

      overlayElement.classList.toggle("is-visible");
      drawer.classList.toggle("Drawer__Custom--open");
      drawer.setAttribute("aria-hidden", !drawer.getAttribute("aria-hidden"));
      document.documentElement.classList.toggle("no-scroll");

      var hideDrawer = () => {
        overlayElement.classList.remove("is-visible");
        drawer.classList.remove("Drawer__Custom--open");
        drawer.setAttribute("aria-hidden", false);
        document.documentElement.classList.remove("no-scroll");
      };

      // var openDrawer = () => {
      //     overlayElement.classList.add('is-visible')
      //     drawer.classList.add('Drawer__Custom--open')
      //     drawer.setAttribute('aria-hidden', true)
      //     document.documentElement.classList.add('no-scroll');
      // }

      var closeElement = drawer.querySelector(".Drawer__Custom--close");

      closeElement.addEventListener("click", hideDrawer);

      if (drawer.classList.contains("Drawer__Custom--open")) {
        overlayElement.addEventListener("click", hideDrawer);
      } else {
        overlayElement.removeEventListener("click", hideDrawer);
      }

      var drawerContent = drawer.querySelector(".Drawer__Custom--content");

      if (select.hasAttribute("data-size-select")) return;

      drawerContent.querySelectorAll("button")?.forEach((button) =>
        button.addEventListener("click", function () {
          if (button.hasAttribute("data-disabled")) return;
          slimselectInstance.setSelected(button.value);
          overlayElement.classList.remove("is-visible");
          drawer.classList.remove("Drawer__Custom--open");
          drawer.setAttribute("aria-hidden", false);
          document.documentElement.classList.remove("no-scroll");
        })
      );
    };

    var element = document.querySelector(`.ss-main.${selectID}`);

    var attachListeners = () => {
      if (innerWidth >= 641) {
        element.removeEventListener("click", handleMobile);
        element.classList.remove("ss-hidden-options");
      } else {
        element.addEventListener("click", handleMobile);
      }
    };

    window.addEventListener("resize", attachListeners);
    attachListeners();
  });

  //make promise just to wait 50ms for slimselect to render
  await new Promise((resolve) => setTimeout(resolve, 50));

  replaceSelectsArrows();
};

var replaceSelectsArrows = () => {
  var allExpandIcons = document.querySelectorAll(".ss-arrow");

  if (!allExpandIcons) return;

  allExpandIcons.forEach((icon) => {
    var temp = document.createElement("div");
    temp.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12.626" height="6.808" viewBox="0 0 12.626 6.808">
  <g id="Group_1239" data-name="Group 1239" transform="translate(12.131 0.495) rotate(90)">
    <line id="Line_14" data-name="Line 14" x2="5.818" y2="5.818" transform="translate(0 0)" fill="none" stroke="#000" stroke-linecap="square" stroke-width="0.7"/>
    <line id="Line_15" data-name="Line 15" x1="5.818" y2="5.818" transform="translate(0 5.818)" fill="none" stroke="#000" stroke-linecap="square" stroke-width="0.7"/>
  </g>
</svg>`;

    var newIcon = temp.firstChild;
    icon.replaceWith(newIcon);
    newIcon.classList.add("ss-arrow");
  });
};

// window.sizeSlimSelect = new Promise()
var handleCartRecommendations = async () => {
  var cartElement = document.querySelector("#sidebar-cart");

  if (!cartElement) return;

  var cartRecommendationsElement = cartElement.querySelector(
    ".cart__recomendations"
  );
  var delegateElement = new domDelegate.Delegate(cartRecommendationsElement);
  //ids of products that are already in cart

  if (!cartRecommendationsElement) return;

  if (!cartRecommendationsElement.dataset.manual) {
    var isCartEmpty = cartRecommendationsElement.dataset.cartProductsIds
      ? false
      : true;

    //products ids we fetch recommendations for, if there is no items in cart, we fetch recommendations for first 5 item in products object
    var productsIds =
      cartRecommendationsElement.dataset.cartProductsIds ??
      cartRecommendationsElement.dataset.cartRecommendationsIds;

    if (!productsIds) return;
    productsIds = productsIds.split(",");

  function* getNextProductID() {
    var index = 0;

    while (true) yield productsIds[index++];
  }

  var productIdsGenerator = getNextProductID();
  var productID = productIdsGenerator.next().value;

  var getProducts = () =>
    fetch(
      `${window.Shopify.routes.root}recommendations/products?product_id=${productID}&section_id=cart-recommendations`
    )
      .then((response) => response.text())
      .then((html) => {
        cartRecommendationsElement.innerHTML = html;
        return cartRecommendationsElement.querySelectorAll("[data-product-id]");
      });

  var products = await getProducts();

  //if there is no recommendations for first item in cart, try to get recommendations for second item in cart
  while (products.length === 0) {
    productID = productIdsGenerator.next().value;

    if (!productID) {
      productsIds =
        cartRecommendationsElement.dataset.cartRecommendationsIds.split(",");
      productIdsGenerator = getNextProductID();
      productID = productIdsGenerator.next().value;
    }

    products = await getProducts();
    break;
  }

  if (!isCartEmpty) {
    products.forEach((element) => {
      if (productsIds.includes(element.dataset.productId)) {
        element.remove();
      }
    });
  }

  }

  cartRecommendationsElement.classList.remove("updating");

  var handleAddToCart = (e) => {
    e.preventDefault();
    var element = e.target.closest(".cart__item");

    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    var item = {
      quantity: 1,
      id: element.dataset.variant,
      properties: {},
    };

    if (window.GloboPreorderParams) {
      var { products } = window.GloboPreorderParams.preorderSettings;

      if ( products ) {
        for (var variations of Object.values(products)) {
          if (variations?.[element.dataset.variant]?.status) {
            item.properties["_is_preorder"] =
              window.GloboPreorderParams.translation.default.preorderedItemlabel;
            item.properties["_preorder_locale"] =
              window.GloboPreorderParams.locale;
          }
        }
      }
      
    }

    fetch(`${window.Shopify.routes.root}cart/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [item],
      }),
    }).then((response) => {
      document.dispatchEvent(
        new CustomEvent("product:added", {
          detail: {
            quantity: 1,
          },
        })
      );
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    });
  };

  delegateElement.on("click", '[data-action="add-to-cart"]', handleAddToCart);
};

// var handleToast = () => {
//   var toastElement = document.querySelector("#Toast");

//   if (!toastElement) return;

//   var toastClose = toastElement.querySelector(".Toast__Close");

//   toastClose.addEventListener("click", () => {
//     toastElement.classList.remove("active");
//   });
// };

var handleToast = async (e) => {
  var toastWrapperElement = document.querySelector("#ToastWrapper");

  if (!toastWrapperElement) return;

  //get first toast element inside toastWrapperElement and save it as template element
  var toastTemplateElement = toastWrapperElement.firstElementChild;

  //create new toast element from template element
  var toastElement = toastTemplateElement.cloneNode(true);

  toastElement.classList.remove("template");

  //add toast element to toastWrapperElement
  toastWrapperElement.appendChild(toastElement);

  switch (e.type) {
    case "toast:error":
      toastElement.classList.add("error");
      break;
    case "toast:success":
      toastElement.classList.add("success");
      break;
    case "toast:info":
      toastElement.classList.add("info");
      break;
  }

  await new Promise((resolve) => setTimeout(resolve, 20));

  toastElement.classList.add("active");

  toastElement.querySelector(".Toast__Message").innerHTML = e.detail.message;

  var deleteToast = async () => {
    toastElement.classList.remove("active");
    await new Promise((resolve) => setTimeout(resolve, 300));
    toastWrapperElement.removeChild(toastElement);
  };

  toastElement
    .querySelector(".Toast__Close")
    .addEventListener("click", deleteToast);
  setTimeout(deleteToast, 5000);
};

document.addEventListener("toast:error", handleToast);

var handleNewsletter = () => {
  var formElement = document.querySelector("form.Newsletter");
  var newsletterElement = formElement?.querySelector(
    ".Newsletter .Newsletter__Inner"
  );

  if (!newsletterElement) return;

  var newsletterInputWrapper = newsletterElement.querySelector(
    ".Newsletter__InputWrapper"
  );
  var newsletterInput = newsletterInputWrapper.querySelector(
    ".Form__Input[type='email']"
  );

  newsletterInput.addEventListener("keyup", () => {
    if (newsletterInput.value) newsletterInputWrapper.classList.add("filled");
    else newsletterInputWrapper.classList.remove("filled");
  });
};

var handleNewsletterModal = () => {
  if (getCookie("newsletterModal") === "closed") return;

  var newsletterModalElement = document.querySelector(
    '.modal[data-modal-id="newsletter"]'
  );

  if (!newsletterModalElement) return;

  //open this modal after 5 seconds
  setTimeout(() => {
    newsletterModalElement.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("no-scroll");
  }, 5000);

  //create observer to watch for newsletter modal close
  var newsletterModalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes") {
        if (mutation.target.getAttribute("aria-hidden") === "true") {
          setCookie("newsletterModal", "closed", 365);
        }
      }
    });
  });

  newsletterModalObserver.observe(newsletterModalElement, {
    attributes: true,
  });
};

document.addEventListener("cart:rerendered", handleCartRecommendations);

var handleDashboard = () => {
  if (routes.accountUrl != window.location.pathname) return;

  var menuElements = document.querySelectorAll("[data-action='toggle-tab']");

  if (!menuElements) return;

  var toggleTab = (id, disableOther) => {
    var tab = document.querySelector(
      `[data-action="toggle-tab"][data-tab-id="${id}"]`
    );
    var tabId = tab.dataset.tabId;
    var tabContent = document.querySelector(tabId);

    if (!tabContent) return;

    window.location.hash = tabId;

    if (disableOther) {
      document
        .querySelectorAll('[data-action="toggle-tab"]')
        .forEach((element) => {
          element.closest("li").classList.remove("active");
          element.classList.remove("active");
        });
      document
        .querySelectorAll(".Tab[aria-hidden='false']")
        .forEach((element) => element.setAttribute("aria-hidden", "true"));
    }

    tab.closest("li").classList.add("active");
    tab.classList.add("active");
    tabContent.setAttribute("aria-hidden", "false");
  };

  var anchor = window.location.hash;
  if (!anchor) {
    anchor = menuElements[0].dataset.tabId;
    window.location.hash = anchor;
  }

  toggleTab(anchor, false);

  menuElements.forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();
      var tab = e.target.closest('[data-action="toggle-tab"]');
      var tabId = tab.dataset.tabId;

      toggleTab(tabId, true);
    });
  });
};

var initCarousels = () => {
  window.initProductCardMedia();
};
window.matchMedia("(max-width: 640px)").addEventListener("change", initCarousels);

var setupCartDrawerCloseHandlers = () => {
  const cartDrawer = document.querySelector('#sidebar-cart');
  const pageOverlay = document.querySelector('.PageOverlay');
  
  if (!cartDrawer) return;

  // Close handler function
  const closeDrawer = () => {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
    }
  };

  // Close button handler
  const closeButton = cartDrawer.querySelector('.Drawer__Close, [class*="close"], [data-action="close-drawer"]');
  if (closeButton) {
    closeButton.addEventListener('click', closeDrawer);
  }

  // PageOverlay click handler
  if (pageOverlay) {
    pageOverlay.addEventListener('click', closeDrawer);
  }
};

var initActions = [
  createCountdown,
  adjustHelpMenu,
  adjustSidebar,
  handleBaner,
  handleBlogTabs,
  handleShopTheLook,
  handleProductListingVideo,
  handleAlternateOnVideo,
  handleListingInfiniteScroll,
  handleListingLoadMoreButton,
  handleBanerVideos,
  handleModal,
  handleCustomSelects,
  handleNewsletter,
  handleNewsletterModal,
  handleDashboard,
  initCarousels,
  handleQuickAddToCart,
];
var resizeObserverActions = [adjustHelpMenu, adjustSidebar];
var dynamicSectionsActions = [
  handleProductListingVideo,
  handleAlternateOnVideo,
  handleListingInfiniteScroll,
  initCarousels,
  handleQuickAddToCart,
];

document.addEventListener('scroll', function() {
  handleResizeQuickAddToCart();
});

document.addEventListener("cart:rerendered", () => {
  var cartSizeSelects = document.querySelectorAll(
    ".CartItem__SizeSelector select"
  );

  cartSizeSelects.forEach(async (select) => {
    if (!select.hasAttribute("id")) {
      new SlimSelect({
        select,
        settings: {
          closeOnSelect: true,
          hideSelected: true,
          contentPosition: "relative",
          contentLocation: select.closest(".Select__Wrapper"),
          showSearch: false,
          showContent: "down",
        },
      });
      select.dispatchEvent(new Event("cart:customSelects"));
    }
  });

  replaceSelectsArrows();
});

document.addEventListener("theme:loading:end", () => {
  dynamicSectionsActions.forEach((action) => action());
});

addEventListener("DOMContentLoaded", () => {
  initActions.forEach((action) => action());
});

var resizeObserver = new ResizeObserver((entries) => {
  for (var entry of entries) {
    resizeObserverActions.forEach((action) => action());
  }
});

resizeObserver.observe(document.body);

document.addEventListener('lookfyCartAdded', function(event) {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
});